import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../Grid';
import Input from '../Input';
import Form from '../Form';
import Popup from '../Popup';
import cx from 'classnames';
import Button from '../Button';
import SaveChangesButton from '../SaveChangeButtonPopup';
import s from './SafeTechPopup.css';
import Messages from './Messages';
import { setDeviceCommandValue } from '../../actions/device';

class AddProfilePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileName: '',
    };
  }

  onClick = () => {
    const { serial, nextProfile } = this.props;
    if (this.state.profileName) {
      this.props.setDeviceCommandValue(serial, `setPN${nextProfile}`, this.state.profileName);
      this.props.setDeviceCommandValue(serial, `setPA${nextProfile}`, 1);
    }
    this.props.onClose();
  };

  onFieldChange = (field, e) => {
    this.setState({
      [field]: e,
    });
  };

  render() {
    const { intl, devicetype, serial } = this.props;
    const messages = Messages();

    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        devicetype={devicetype}
        overrideOnClose
      >
        <Form onSubmit={this.onSubmit}>
          <Grid.Cell>
            <Input
              type="text"
              name="profileName"
              title={intl.formatMessage(
                messages.safetech_popup_add_profile,
              )}
              onChange={this.onFieldChange.bind(this, 'profileName')}
              titleVisibility
            />
          </Grid.Cell>
          <SaveChangesButton devicetype={devicetype} onClick={this.onClick} />
        </Form>
      </Popup>
    );
  }
}

AddProfilePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  setDeviceCommandValue: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  nextProfile: PropTypes.number.isRequired,
};

AddProfilePopup.defaultProps = {

};

const mapDispatch = dispatch => {
  return {
    saveDeviceData: (serial, data) => dispatch(saveDeviceData(serial, data)),
    setDeviceCommandValue: (deviceId, command, value) => 
       dispatch(setDeviceCommandValue(deviceId, command, value)),
  };
};

export default injectIntl(
  compose(connect(null, mapDispatch), withStyles(s))
  (AddProfilePopup)
);



// WEBPACK FOOTER //
// ./src/components/SafeTechPopup/AddProfilePopup.js